module.exports = __webpack_public_path__ + "static/media/selfie.bb1dc9a1.svg";